import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const styles = {
  startColumn: {
    container: css`
      display: flex;
      gap: ${theme.spacing(1)};
      align-items: center;
    `,
  },
  rowHeader: {
    container: css`
      display: flex;
      align-items: center;
      gap: ${theme.spacing(1)};
    `,
    locationButton: css`
      background-color: ${theme.colors.neutral5};
    `,
  },
};
